import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Form from '../../components/form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class FloorDetail extends React.Component {
  constructor(props) {
    super(props);

    this.formRef = undefined;
  }

  getFloorData() {
    return this.formRef.getFormData();
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}`: item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  render() {
    const { name, area, description } = this.props.floor || {};

    const { t, disabled, fieldErrors, isShowArea, ...otherAttr } = this.props;
    const customAttr = { disabled };

    return (
      <Form
        {...otherAttr}
        showThumbnail={false}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="floor-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        {isShowArea && <FieldGroup
            id="floor-area"
            field="area"
            type="number"
            label={t('area')}
            placeholder="1000"
            value={area}
            validators={[requiredValidator]}
            errorMessage={getErrorValue(fieldErrors, 'area')}
            {...customAttr}
            disabled={true}
        />}
        <FieldGroup
          id="floor-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
});


export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    null,
    null,
    { withRef: true },
  )(FloorDetail),
);



// WEBPACK FOOTER //
// ./src/components/floor/FloorDetail.js